import React, { useState } from 'react';

import ImageUpload from '@components/ImageUpload';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const AddNewBrand = ({ triggerBrandModal, setNewBrandToSelectedBrand, brandName }) => {
	const [loading, setLoading] = useState(false);
	const [brandInfo, setBrandInfo] = useState({ name: brandName });
	const [errors, setErrors] = useState({
		brandNameError: ''
	});

	const onBrandChange = (e) => {
		e.preventDefault();
		setErrors({
			...errors,
			brandNameError: ''
		});
		setBrandInfo({
			...brandInfo,
			[e.target.id]: e.target.value
		});
	};

	const onAdd = async () => {
		if (!('name' in brandInfo) || brandInfo.name === '') {
			setErrors({
				...errors,
				brandNameError: 'Brand name is required'
			});
			return false;
		}

		let body = brandInfo;
		setLoading(true);
		await ApiClient.POST('addBrandInfo', body)
			.then(({ data }) => {
				setLoading(false);
				if (setNewBrandToSelectedBrand !== undefined) {
					setNewBrandToSelectedBrand(data.id);
				}
				if (data && data.success) {
					toastSuccess(data.message);
					triggerBrandModal();
				}
			})
			.catch(({ response }) => {
				setLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onUploadImage = (image) => {
		setBrandInfo({
			...brandInfo,
			logoDocumentDTO: image
		});
	};

	return (
		<>
			<div className="brand-container">
				<div className="form-container new-brand ">
					<div className="form-header border-bottom-modal pb-3">
						<p className="semibold-18">Add brand</p>
					</div>
					<div className="container px-0">
						<div className="row form-row border-0 pt-3 pb-0 px-2">
							<div className="col-md-12">
								<h2 className="semibold-16 form-title">Brand basic info</h2>
							</div>
							<div className="col-md-3">
								<div className="form-group">
									<div className="upload-design-image mb-4 mb-sm-0">
										{brandInfo?.logoDocumentDTO ? (
											<>
												<img
													className="border-0"
													src={
														brandInfo?.logoDocumentDTO?.base64Str
															? brandInfo?.logoDocumentDTO?.base64Str
															: ''
													}
													alt=""
												/>
												<ImageUpload
													onUploadImage={onUploadImage}
													docType={'ACCESSORIES_DESIGN'}
													type={'image'}
													isEditable={true}
												/>
											</>
										) : (
											<ImageUpload
												onUploadImage={onUploadImage}
												docType={'ACCESSORIES_DESIGN'}
												type={'image'}
											/>
										)}
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="bname">Brand name*</label>
									<input
										type="text"
										autoComplete="off"
										placeholder="Type brand name"
										className="bg-gray-light border-0"
										name="name"
										id="name"
										value={brandInfo.name}
										onChange={onBrandChange}
									/>
									{errors.brandNameError && (
										<p className="error">{errors.brandNameError}</p>
									)}
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="legalName">Brand legal name</label>
									<input
										type="text"
										autoComplete="off"
										id="legalName"
										value={brandInfo.legalName}
										onChange={onBrandChange}
									/>
								</div>
							</div>
							<div className="col-md-6 pr-10">
								<div className="form-group">
									<label htmlFor="email">Email</label>
									<input
										type="email"
										autoComplete="off"
										id="email"
										value={brandInfo.email}
										onChange={onBrandChange}
									/>
								</div>
							</div>
							<div className="col-md-6 pl-10">
								<div className="form-group">
									<label htmlFor="phone">Phone</label>
									<input
										type="number"
										autoComplete="off"
										id="phone"
										value={brandInfo.phone}
										onChange={onBrandChange}
									/>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group mb-0">
									<label htmlFor="website">website</label>
									<input
										type="text"
										autoComplete="off"
										id="website"
										value={brandInfo.website}
										onChange={onBrandChange}
									/>
								</div>
							</div>
						</div>
						<div className="row mb-3">
							<div className="col-md-12 text-right">
								<button
									className="button gray-outline mr-2 size32"
									onClick={triggerBrandModal}
								>
									Close
								</button>

								<button className="button size32" onClick={() => onAdd()}>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<LoaderComponent loading={loading} />
		</>
	);
};

export default AddNewBrand;
